import { Component, inject } from '@angular/core';
import { AsyncPipe, DOCUMENT, NgIf } from '@angular/common';
import { environment } from '../../environments/environment';
import { CommonDataPassService } from '../common-resource/services/common-data-pass.service';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [NgIf,AsyncPipe],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  finkupUrl = environment.finkupUrl
  document = inject(DOCUMENT)
  commonDataPass = inject(CommonDataPassService)

  loading$ = this.commonDataPass.routeLoading$;

}
